import { treaty } from "@elysiajs/eden"

import type { AppHttpApp } from "@/adapters/http/server"

import { getCsrfTokenFromDocumentCookie } from "./auth-api"

const getEdenBaseUrl = (): string => {
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin
  }

  if (
    typeof globalThis.location !== "undefined" &&
    globalThis.location?.origin
  ) {
    return globalThis.location.origin
  }

  return ""
}

export const http = treaty<AppHttpApp>(getEdenBaseUrl(), {
  headers: () => {
    const csrfToken = getCsrfTokenFromDocumentCookie()
    return csrfToken ? { "x-csrf-token": csrfToken } : undefined
  },
})
